export default "__VITE_ASSET__DA3wGVx6__"